import axiosInstance from './axiosInstance';

const createImpersonate = (merchant) =>
  axiosInstance.post(`/internal/admin/merchants/${merchant}/impersonate`);

export default createImpersonate;
